import { render, staticRenderFns } from "./VenueSelector.vue?vue&type=template&id=2f87113c&scoped=true&"
import script from "./VenueSelector.vue?vue&type=script&lang=js&"
export * from "./VenueSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87113c",
  null
  
)

export default component.exports